import { clsx } from 'clsx';

/** Theme-aware shimmer block (see .skeleton in index.css). */
export function Skeleton({ className }: { className?: string }) {
  return <div className={clsx('skeleton', className)} />;
}

/** Placeholder table body while a list query loads — shimmer rows, not text. */
export function TableSkeletonRows({ colSpan, rows = 5 }: { colSpan: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className="border-b border-border/50">
          <td colSpan={colSpan} className="px-4 py-3.5">
            <Skeleton className="h-4 w-full" />
          </td>
        </tr>
      ))}
    </>
  );
}

/** Stacked shimmer bars for non-table loading states. */
export function SkeletonBlock({ rows = 5, className }: { rows?: number; className?: string }) {
  return (
    <div className={clsx('space-y-2', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-11 w-full" />
      ))}
    </div>
  );
}
